import { captureException } from "@sentry/vue";

import { type PushNotificationStore, usePushNotificationsStore } from "../Store";

import PushNotificationsAPIConnector from "@/Services/TherapyApi/PushNotifications";

import { danger } from "@/Utils/Debug";
import { isAndroidApp } from "@/Utils/Ionic";
import { PUSH_PLATFORM } from "../Models/constants";
import { hasValue } from "@/Utils/Objects";

class PostPushTokenActionHandler {
  constructor(
    private readonly pushStore: PushNotificationStore = usePushNotificationsStore(),
    private readonly pushApi = new PushNotificationsAPIConnector()
  ) {}

  public async handle(token: string): Promise<string | undefined> {
    this.pushStore.token = token;
    this.pushStore.isAvailable = true;

    try {
      const response = await this.pushApi.createToken(
        token,
        isAndroidApp() ? PUSH_PLATFORM.ANDROID : PUSH_PLATFORM.IOS
      );

      if (hasValue(response)) {
        return response.pushtoken;
      } else {
        this.pushStore.isAvailable = false;

        return undefined;
      }
    } catch (e) {
      danger("Error posting push token", e);

      captureException(e);
      this.pushStore.isAvailable = false;

      return undefined;
    }
  }
}

export default PostPushTokenActionHandler;
